import React, { useCallback, useMemo } from 'react'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import Filter from 'ui/components/filter'
import Divider from '@material-ui/core/Divider'
import { ReactComponent as IconList } from 'assets/icons/list.svg'
import { ReactComponent as IconVerified } from 'assets/icons/verified.svg'
import { ReactComponent as IconDenied } from 'assets/icons/denied.svg'
import useTranslation from 'hooks/useTranslations'
import useStyles from './filtersStyles'

const Filters = ({ filters, setFilters }) => {
  const classes = useStyles()
  const t = useTranslation()

  const handleRemoveFilters = useCallback(() => {
    setFilters({})
  }, [setFilters])

  const handleSetHomologated = useCallback(() => {
    setFilters({ ...filters, homologated: true })
  }, [filters, setFilters])

  const handleUnsetHomologated = useCallback(() => {
    setFilters({ ...filters, homologated: false })
  }, [filters, setFilters])

  const isHomologatedSelected = useMemo(
    () => filters.hasOwnProperty('homologated'),
    [filters],
  )

  return (
    <Box mt={3} mb={1}>
      <Grid container wrap="nowrap" className={classes.root}>
        <Filter
          icon={IconList}
          label={t('filter:all')}
          selected={!isHomologatedSelected}
          setSelected={handleRemoveFilters}
        />
        <Divider className={classes.divider} orientation="vertical" flexItem />
        <Filter
          icon={IconVerified}
          label={t('filter:homologate')}
          selected={isHomologatedSelected && filters.homologated}
          setSelected={handleSetHomologated}
        />
        <Filter
          icon={IconDenied}
          label={t('filter:no-homologate')}
          selected={isHomologatedSelected && !filters.homologated}
          setSelected={handleUnsetHomologated}
        />
      </Grid>
    </Box>
  )
}
export default Filters
